module.exports = __webpack_public_path__ + "static/media/splash.5179de69.png";